var MpPageEquipments;

(function() {
    if (!document.querySelector('#vue-body-equipment')) {
        return;
    }

    Vue.component('multiselect', window.VueMultiselect.default);

    MpPageEquipments = new Vue({
        el: '#vue-body-equipment',
        data: {
            EQUIPMENT_SEARCH_PAGE_URL: '/equipment/index/format/json',

            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',

            totalResultsTPL: '',
            totalItems: 0,

            word: '',
            categories: [],
            categoryCheckList: [],
            filters: '',

            allChecked: false,

            companyList: [],

            firstRender: true,
            isInitialized: false,
        },
        computed: {

            dataSearch: function() {
                return Serializer.serialize({
                    'filters': 'ok',
                    'word': this.word,
                });
            },

            isFilteredByCategory: function() {
                return this.categories.length;
            },

            dataFilters: function() {
                return Serializer.serialize({
                    'word': this.word,
                    'categories': this.categories,
                    'filters': this.filters
                });
            },

            totalResults: function () {
                return this.totalResultsTPL.replace('%s', this.totalItems);
            },

        },
        methods: {

            addCategoryCheck: function(checkItem) {
                this.categoryCheckList.push(checkItem);

                if (checkItem.getAttribute('checked')) {
                    this.categories.push(checkItem.value);
                }
            },

            setAllChecks: function(value) {
                var i;

                this.allChecked = value;
                this.categories = [];

                for (i=0; i<this.categoryCheckList.length; i++) {
                    this.categoryCheckList[i].checked = this.allChecked;
                    if (this.allChecked) {
                        this.categories.push(this.categoryCheckList[i].value);
                    }
                }
            },

            filterById: function(list, idList) {
                return list.filter(function (item) {
                    return idList.indexOf(item.id) >= 0;
                });
            },

            resetFilters: function() {
                this.word = '';
                this.setAllChecks(false);

                this.doSearch();
            },

            addDomItem: function(item) {
                this.companyList.push({
                    id: item.getAttribute('data-id'),
                    link: item.querySelector('.js-item-link').getAttribute('href'),
                    logo: item.querySelector('.js-item-logo').getAttribute('src'),
                    company: item.querySelector('.js-item-company').innerText.trim(),
                    resume: item.querySelector('.js-item-resume').innerHTML.trim(),
                    last: 0,
                    phone: '',
                    cell: '',
                    email: '',
                    web: '',
                });
            },

            onSearchLoaded: function(response) {
                if (response.data.result == this.RESPONSE_OK) {
                    this.firstRender = false;
                    this.companyList = response.data.equipments;
                    this.totalItems = response.data.total;
                }
            },

            doSearch: function() {

                axios
                .post(this.EQUIPMENT_SEARCH_PAGE_URL, this.dataFilters)
                .then(this.onSearchLoaded)
                .catch(function(error) {
                    console.log(error);
                });
            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;
            },
        },

        filters: {},

        mounted: function() {
            this.$refs.ssrItemList.querySelectorAll('.js-item').forEach(this.addDomItem);
            this.$refs.ssrCategoryList.querySelectorAll('.js-category-check').forEach(this.addCategoryCheck);

            this.word = this.$refs.word.getAttribute('data-init');
            this.filters = this.$refs.filters.getAttribute('data-init');
            this.totalResultsTPL = this.$refs.ssrTotalItems.getAttribute('data-tpl');
            this.totalItems = this.$refs.ssrTotalItems.getAttribute('data-total');

            this.init();
        },

        updated: function() {
            if (!this.isInitialized) {
                this.init();
            }
        },

        destroy: function() {}
    });

})();
